import {NkCarousel} from '#build/components';

const globals = {
	floats: {
		left: 'float-left',
		right: 'float-right',
	},
	positions: {
		left: 'left-0',
		right: 'right-0',
		top: 'top-0',
		bottom: 'bottom-0',
	},
	aspectRatios: {
		auto: 'aspect-auto',
		'1/1': 'aspect-[1/1]',
		'16/9': 'aspect-[16/9]',
		'21/9': 'aspect-[21/9]',
		'4/3': 'aspect-[4/3]',
		'5/6': 'aspect-[5/6]',
	},
	fontSizes: {
		sm: 'text-sm',
		base: 'text-base',
		md: 'text-md',
		lg: 'text-lg',
		xl: 'text-xl',
		'2xl': 'text-2xl',
		'3xl': 'text-3xl',
		'4xl': 'text-4xl',
		'5xl': 'text-5xl',
	},
	justifyContent: {
		normal: 'justify-normal',
		start: 'justify-start',
		end: 'justify-end',
		center: 'justify-center',
		between: 'justify-between',
		around: 'justify-around',
		evenly: 'justify-evenly',
		stretch: 'justify-stretch',
	},
};

const settings = {
	NkAddress: {
		fixedClasses: {
			wrapper: 'nk-address leading-relaxed',
			text: null,
		},
		variants: {
			default: {
				wrapper: 'flex flex-col sm:flex-row -mx-3 -my-2',
				text: 'w-full px-3 py-2 m-0',
			},
			vertical: {
				wrapper: 'flex flex-col',
				text: 'm-0',
			},
		},
		text: {
			anfahrtPlanen: 'Anfahrt planen',
			anfahrtPlanenAriaLabel: 'Anfahrt planen mit Google Maps',
			emailSchreiben: 'E-Mail schreiben',
			telefon: 'Telefon:',
			mobil: 'Mobil:',
			telefax: 'Telefax:',
		},
	},
	NkList: {
		variants: {
			unstyled: 'list-none p-0 m-0',
		},
	},
	NkIcon: {
		icons: {
			'down-arrow-alt': ' bx-down-arrow-alt',
			'left-arrow-alt': ' bx-left-arrow-alt',
			'right-arrow-alt': ' bx-right-arrow-alt',
			'info-circle': ' bx-info-circle',
		},
		variants: {
			boxed: 'p-[0.25em] text-center rounded-full bg-secondary-700 text-white',
		},
	},
	NkDate: {
		variants: {
			calendar: {
				day: 'text-2xl font-semibold leading-none',
				month: 'text-base uppercase tracking-wide leading-none',
				wrapper: 'inline-flex flex-col text-primary-700 text-center',
			},
		},
	},
	NkBadge: {
		fixedClasses:
			'nk-badge cursor-default inline-block px-3 py-1 rounded-full font-semibold uppercase spacing-wide',
		sizes: {
			xs: 'text-xs',
			sm: 'text-sm',
			base: 'text-base',
			md: 'text-md',
			lg: 'text-lg',
		},
	},
	NkButton: {
		fixedClasses:
			'nk-button inline-flex items-center gap-2.5 transition duration-300 ease-out font-semibold relative no-underline',
		variants: {
			solid: 'nk-solid rounded-full',
			outline: 'nk-outline border-2 rounded-full',
			link: 'nk-link border-b-2 flex justify-start items-center transition-all duration-150 relative left-0 hover:left-1',
			ghost: 'nk-ghost transition-all duration-150 left-0 hover:left-1',
		},
		colors: {
			primary:
				'[&.nk-solid]:bg-primary-element [&.nk-solid]:hover:bg-primary-element--hover [&.nk-solid]:focus:bg-primary-element--active [&.nk-solid]:text-white [&.nk-solid]:hover:text-white [&.nk-link]:border-primary-element [&.nk-link]:text-primary-text [&.nk-link]:hover:text-primary-text--hover [&.nk-link]:hover:border-primary-element--hover [&.nk-ghost]:text-primary-text [&.nk-ghost]:hover:text-primary-text--hover [&.nk-ghost]:hover:border-primary-element--hover [&.nk-outline]:border-primary-element [&.nk-outline]:text-primary-text [&.nk-outline]:hover:text-primary-text--hover [&.nk-outline]:hover:border-primary-element--hover',
			secondary:
				'[&.nk-solid]:bg-secondary-element [&.nk-solid]:hover:bg-secondary-element--hover [&.nk-solid]:focus:bg-secondary-element--hover [&.nk-solid]:text-white [&.nk-solid]:hover:text-white [&.nk-link]:border-secondary-element [&.nk-link]:text-secondary-text [&.nk-link]:hover:text-secondary-text--hover [&.nk-link]:hover:border-secondary-element--hover [&.nk-ghost]:text-secondary-text [&.nk-ghost]:hover:text-secondary-text--hover [&.nk-ghost]:hover:border-secondary-element--hover [&.nk-outline]:border-secondary-element [&.nk-outline]:text-secondary-text [&.nk-outline]:hover:text-secondary-text--hover [&.nk-outline]:hover:border-secondary-element--hover',
			light:
				'[&.nk-link]:border-secondary-element [&.nk-link]:text-white [&.nk-link]:hover:text-white [&.nk-link]:hover:border-secondary-element--hover [&.nk-ghost]:text-white [&.nk-ghost]:hover:text-white [&.nk-ghost]:focus:text-white [&.nk-outline]:border-white [&.nk-outline]:text-white [&.nk-outline]:hover:text-white [&.nk-outline]:hover:border-primary-100',
		},
		sizes: {
			default: 'px-5 py-2 ',
			sm: 'p-2.5',
			collapse: 'p-0 [&.nk-link]:p-1',
		},
	},
	NkCarousel: {
		variants: {
			hero: {
				sliderItem:
					'flex items-center h-full aspect-[3/4] lg:aspect-[16/9] lg:aspect-[21/9] max-h-screen',
				slideContent:
					'relative z-10 py-24 sm:py-10 px-3 sm:px-12 2xl:px-24 text-shadow-sm flex h-full items-center justify-center',
				buttonWrapper:
					'absolute top-5 right-5 flex gap-1 my-6 px-3 -translate-y-1/2 transform z-20',
				button:
					'transition ease-out duration-300 justify-center items-center text-center gap-8 rounded-full text-white/50 text-xl hover:text-white/75 focus:text-white bg-primary-element hover:bg-primary-element--hover focus:bg-primary-element--hover inline-flex w-10 h-10',
				paginationWrapper:
					'absolute w-full bottom-0 sm:bottom-20 block z-10 my-6 -translate-y-1/2 transform',
			},
			topthema: {
				sliderOptions: {
					spaceBetween: 0,
					slidesPerView: 1,
					speed: 600,
					centeredSlides: true,
					navigation: true,
					effect: 'fade',
					autoplay: {
						delay: 8000,
					},
					fadeEffect: {
						crossFade: true,
					},
				},
				wrapper: 'h-full min-h-full relative w-full',
				slider: 'h-full min-h-full',
				sliderItem: 'h-full min-h-full',
				slideContent: 'relative z-10 h-full min-h-full',
				controls: 'mt-4',
				buttonWrapper:
					'absolute top-0 right-0 px-3 translate-y-1/2 transform z-20 space-x-2',
				button:
					'transition ease-out shadow-lg duration-300 justify-center items-center rounded-full text-center text-secondary-text bg-white hover:text-secondary-text--active focus:text-secondary-text--active text-sm w-12 h-12',
				buttonLeftIcon: 'left-arrow-alt',
				buttonRightIcon: 'right-arrow-alt',
				buttonLeft: '',
				buttonRight: '',
				buttonDisabled: 'opacity-50 cursor-not-allowed pointer-events-none',
				paginationWrapper: 'block',
				pagination: 'flex justify-center md:justify-end list-none -mx-1',
				paginationButton:
					'block w-5 h-5 mx-1 rounded-full bg-secondary-element opacity-50 hover:opacity-75 is-active:opacity-100 transition focus-visible:scale-[90%] focus-visible:outline-white',
				paginationButtonActive: 'is-active',
			},
			'hero-portal': {
				wrapper: 'relative w-full bg-secondary-surface overflow-hidden',
				slider: 'h-full min-h-full',
				sliderItem:
					'flex items-center h-full aspect-[1/1] sm:aspect-[16/9] lg:aspect-[3/1] max-h-screen',
				slideContent:
					'relative z-10 py-10 px-3 sm:px-12 2xl:px-24 text-shadow-sm flex h-full items-center justify-center',
				slideBackgroundImage:
					'absolute top-0 left-0 h-full w-full object-cover',
				slideBackgroundImageContainer: 'absolute top-0 left-0 h-full w-full',
				controls: '',
				buttonWrapper:
					'absolute top-5 right-5 hidden sm:flex gap-1 my-6 px-3 -translate-y-1/2 transform z-20',
				button:
					'transition ease-out duration-300 justify-center items-center text-center gap-8 rounded-full text-white/50 text-xl hover:text-white/75 focus:text-white bg-primary-element hover:bg-primary-element--hover focus:bg-primary-element--hover hidden sm:inline-flex w-10 h-10',
				buttonLeft: '',
				buttonLeftIcon: 'chevron-left',
				buttonRight: '',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed pointer-events-none',
				paginationWrapper:
					'absolute bottom-0 right-20 block z-10 my-6 -translate-y-1/2 transform',
				pagination: 'flex flex-wrap items-center list-none -mx-1',
				paginationButton:
					'block w-8 is-active:w-10 h-3 mx-1 rounded bg-white/50 hover:bg-white/75 is-active:bg-white transition-all',
				paginationButtonActive: 'is-active',
			},
		},
	},
	NkCard: {
		variants: {
			'bpg-erleben-entdecken': {
				wrapper: 'flex flex-col min-h-full h-full gap-3',
				header: 'overflow-hidden rounded-3xl',
			},
		},
	},
	NkDrilldown: {
		fixedClasses: 'nk-drilldown',
		variants: {
			default: {
				menu: 'nk-drilldown bg-neutral-surface rounded overflow-hidden',
				menuInner: 'list-none',
				menuItem: 'border-b border-neutral-border last:border-0',
				menuItemButton:
					'relative flex w-full py-4 px-4 text-primary-text hover:bg-neutral-surface-hover',
				menuItemButtonActive:
					'border-b border-neutral-border text-primary-text',
				menuItemIcon: 'no-underline after',
				menuItemButtonIcon:
					'no-underline absolute right-0 mr-3 transform transition-transform duration-300 ease-in-out ',
				menuItemButtonIconActive: 'rotate-180',
				menuItemLink:
					'flex py-4 px-4 link-active:bg-primary-element link-active:text-white link-active-exact:bg-primary-element link-active-exact:text-white group-[.is-submenu]:pl-8  link-active:hover:text-white link-active-exact:hover:text-white',
				menuItemLinkIcon: 'no-underline',
				submenu: 'bg-neutral-surface--active group is-submenu',
			},
		},
	},
	NkNav: {
		variants: {
			default: {
				wrapper: '',
				item: 'nk-nav-item border-b border-neutral-border text-md',
				title: 'font-bold',
				text: '',
				content: 'inline-block text-base underline',
				link: 'flex items-start justify-start py-3 px-2 transition duration-300 group text-primary-text hover:text-primary-text--hover link-active:bg-primary-surface link-active:text-primary-on-surface',
				prependIcon: {
					icon: 'chevron-right',
					class: 'mr-1',
				},
			},
			quicklinks: {
				wrapper: '',
				list: 'sm:grid grid-cols-2 grid-rows-3 gap-x-6',
				item: 'nk-nav-item border-b border-neutral-border text-md ',
				title: '',
				text: '',
				content: 'inline-block text-base ',
				link: 'nav-link flex items-center py-3 px-2 transition duration-300 group no-underline text-white hover:text-white focus:text-white active:text-white transition-all duration-300 ease-in-out',
				prependIcon: {
					icon: 'right-arrow-alt',
					class: 'mr-1 group-hover:mr-3 transition-all duration-300',
				},
			},

			footprint: {
				wrapper: '-mx-2',
				list: 'flex flex-wrap',
				// focus/active muessen explizit weiss bleiben, sonst greift die
				// globale Regel `a:focus, a:active` aus _base.scss und faerbt den
				// Link nach dem Klick in der Primaerfarbe – auf dem dunklen Footer
				// ist er damit unsichtbar.
				link: 'nav-link flex items-center py-1 px-2 text-white hover:text-white focus:text-white active:text-white focus-visible:text-white no-underline hover:underline transition duration-300 group',
			},
			'footer-column': {
				wrapper: '',
				list: 'flex flex-col',
				item: 'nk-nav-item text-md',
				title: '',
				text: '',
				content: 'inline-block text-base',
				link: 'nav-link flex items-center justify-center md:justify-start py-1 px-2 -mx-2 transition duration-300 group no-underline text-white hover:text-white focus:text-white active:text-white',
				prependIcon: {
					icon: 'right-arrow-alt',
					class: 'mr-1 group-hover:mr-3 transition-all duration-300',
				},
			},
			abc: {
				wrapper: 'flex flex-wrap justify-start',
				item: 'nk-nav-item',
				title: '',
				text: '',
				link: 'flex items-center justify-center size-10 text-lg bg-transparent rounded-full hover:bg-neutral-100 link-active:text-white link-active:font-semibold link-active:bg-primary-500',
			},
		},
	},
	NkImage: {
		classes: {
			copyright:
				'inline-block absolute z-30 opacity-75 leading-none rounded-full p-2 text-white text-sm',
		},
	},
};

export {settings, globals};
